import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles, withStyles } from 'utils/makeStylesAdapter';
import {
  IconButton,
  Typography,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  Dialog,
  Divider,
  Box,
} from '@mui/material';
import MuiDialogTitle from '@mui/material/DialogTitle';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import CloseIcon from '@mui/icons-material/Close';

const styles = theme => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

const DialogTitle = withStyles(styles)(props => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h3">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const useStyles = makeStyles(theme => ({
  nested: {
    paddingLeft: theme.spacing(3),
  },
}));

const ModalSelectManualFile = props => {
  const { open, onClose, files } = props;

  const classes = useStyles();

  const handleOpenFile = file => {
    if (file?.url) {
      window.open(file.url, '_blank');
    }
    onClose();
  };

  return (
    <Dialog
      onClose={onClose}
      aria-labelledby="manual-files-dialog-title"
      open={open}
      fullWidth
      maxWidth="sm"
    >
      <DialogTitle onClose={onClose} id="manual-files-dialog-title">
        Selecione o manual que deseja abrir
      </DialogTitle>
      <Divider />
      <List component="nav">
        {files.map(file => (
          <Box key={file.id || file.name}>
            <ListItem button className={classes.nested} onClick={() => handleOpenFile(file)}>
              <ListItemIcon>
                <PictureAsPdfIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText primary={file.name} />
            </ListItem>
            <Divider />
          </Box>
        ))}
      </List>
    </Dialog>
  );
};

ModalSelectManualFile.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  files: PropTypes.array.isRequired,
};

export default ModalSelectManualFile;
